import { useEffect } from 'react';
import { getDealerDetails, getDealerLoading, getTransferCount } from './ducks/selectors';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  callToGetDealerDetail,
  callToTransferCount,
  toggleLoading
} from '@/dealerProfile/ducks/slice';
import { Breadcrumb, BreadcrumbItem, Image } from '@chakra-ui/react';
import DealerProfileModule from '@/dealerProfile/DealerProfile';
import { getIsMyFFLRole, getIsStoreAdminRole, getIsStoreAgent, getStoreDealerId } from '@/redux/app-selectors';



type Props = {
  isSuperAdmin: boolean
  userPermissions?: any
};

const DealerProfile = ({isSuperAdmin, userPermissions}: Props) => {
  const data = getDealerDetails();
  const transferCount = getTransferCount();
  const loading = getDealerLoading()
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate()
  const isStoreAdminRole = getIsStoreAdminRole();
  const isStoreAgentRole = getIsStoreAgent();
  const storeDealerId = getStoreDealerId();
  const isEditOthers = userPermissions?.profileEdit?.editOthers || false;
  const isEditSelf = userPermissions?.profileEdit?.editSelf || false;

  const isMyFFLRole = getIsMyFFLRole();
  
  const handleFetch = () => {
    if (params.dealerId) {
      dispatch(callToGetDealerDetail(params.dealerId));
      dispatch(callToTransferCount(params.dealerId));
      dispatch(toggleLoading());
    }
  }

  const isEditable = (isStoreAdminRole || isStoreAgentRole) ? (isEditOthers || (isEditSelf && params?.dealerId === storeDealerId)) : true

  useEffect(() => {
    handleFetch()
  }, []);

  return (
    <div>
      <div className='breadcrumb-wrapper'>
    
     
      {!isMyFFLRole && (
        <>
          <Breadcrumb
            spacing="16px"
            separator={
              <Image
                src="/images/ui/right-arrow.svg"
                width="7.41px"
                height="12px"
              />
            }
            padding={0}
          >
            <BreadcrumbItem
              color="#0090C6"
              textDecoration="underline"
              className="breadcrum-item"
              cursor="pointer"
            >
              <span onClick={() => navigate('/dealers-search')}>Search</span>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <span>Dealer Details</span>
            </BreadcrumbItem>
          </Breadcrumb>
        </>
      )}
    </div>
      {params.dealerId && 
      <DealerProfileModule handleFetch={handleFetch} data={data} transferCount={transferCount} isLoading={loading} isSuperAdmin={isSuperAdmin} dealerId = {params.dealerId}  isEditable={isEditable}/>
      }
    </div>
  );
};

export default DealerProfile;
